module.exports = __webpack_public_path__ + "img/download2.3e83806c.jpg";